module.exports = __webpack_public_path__ + "img/app-homepage.5d4a270e.png";